import { render, staticRenderFns } from "./IconMicroLearning.vue?vue&type=template&id=bbe8445e"
import script from "./IconMicroLearning.vue?vue&type=script&lang=js"
export * from "./IconMicroLearning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports